import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ErrorLevel } from 'gw-portals-edge-validation-js';
import { withTracking } from 'gw-portals-tracking-react';
import singleErrorStyles from './WizardSingleErrorComponent.module.scss';
import { messages as commonMessages } from 'gw-platform-translations';

function WizardSingleErrorComponent(props) {
    const { issuesList, acknowledgeError, isNewSubmission, additionalWizardData } = props;
    const showError = _.isUndefined(additionalWizardData.showError) ? true : additionalWizardData.showError;
    const hideWarnings = useCallback(
        (index) => {
            const selectedError = issuesList[index];
            acknowledgeError(selectedError.id);
        },
        [acknowledgeError, issuesList]
    );

    const issuesSection = issuesList.map((issue, index) => {
        const issueType = issue.level === ErrorLevel.LEVEL_ERROR ? 'gwIssuesError' : 'gwIssuesWarning';
        const issueTypeClass = classNames(
            singleErrorStyles.gwIssuesMessage,
            singleErrorStyles[issueType]
        );
        const closeIconClass = classNames(singleErrorStyles.gwIssuesCloseIcon, 'mir', 'mi-close');
        const closeIcon = issue.level === ErrorLevel.LEVEL_WARN ? (
            <div
                role="presentation"
                className={closeIconClass}
                onClick={() => hideWarnings(index)}
            />
        ) : null;
        const issueTypeErrorIconClass = classNames(singleErrorStyles.gwIssuesTypeIcon, 'mir', 'mi-remove-circle-outline');
        const issueTypeWarningIconClass = classNames(singleErrorStyles.gwIssuesTypeIcon, 'mir', 'mi-warning');
        const issueTypeIcon = issue.level === ErrorLevel.LEVEL_WARN ? (
            <div
                role="presentation"
                className={issueTypeWarningIconClass}
            />
        ) :  (
                 <div
                     role="presentation"
                     className={issueTypeErrorIconClass}
                 />
             );

        return (
            <div className={singleErrorStyles.gwIssuesContainer} key={issue.description}>
                { showError && 
                    <div className={issueTypeClass}>
                        {issueTypeIcon}
                        <div className={singleErrorStyles.gwIssuesMessageContainer}>
                            <span>{issue.description}</span>
                        </div>
                        {closeIcon}
                    </div>
                }
            </div>
        );
    });

    
    return (
            <div>
                {issuesList && issuesList.length > 0 &&  showError ? (
                    <>
                        <div><h3 className={singleErrorStyles.gwErrorMessageContainer}>Errors and Warnings</h3></div>
                    </>
                ) : null}
                <div className={singleErrorStyles.gwIssuesMessageContainer}>{issuesSection}</div>
            </div>
        );
}

WizardSingleErrorComponent.propTypes = {
    acknowledgeError: PropTypes.func.isRequired,
    issuesList: PropTypes.shape([])
};
WizardSingleErrorComponent.defaultProps = {
    issuesList: []
};
export default withTracking(WizardSingleErrorComponent);
